module.exports = __webpack_public_path__ + "media/images/logo_transparent-e00f145004b990ea0e171d5c12f86c3d.svg";